import {IUserTicketPrize} from "../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {InGameTicketPrizeType} from "./abstract/in-game-ticket-prize-types";
import {InGameTicketPrizeAbstract} from "./abstract/in-game-ticket-prize.abstract";

export class InGameTicketNoWinPrize extends InGameTicketPrizeAbstract {
    constructor(protected _prizeData: IUserTicketPrize, private services: IServiceFactoryExtended) {
        if (InGameTicketPrizeType.NoWin !== _prizeData.prizeType) {
            throw new Error("NoWin cannot be given this prizeType" + _prizeData.prizeType);
        }
        super(_prizeData);
    }
    public prizeString() {
        return this.services.translation.translate("No win");
    }
}
